export default __webpack_public_path__ + "static/banner91-756972d58e887fe8dfdb40109e6ee12e.svg";